import {Box, Card, Typography, Switch} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {AppContext} from "../../App";
import {StoreContext} from "../../common/struct/store";
import {UPDATE_COMPANY} from "../../common/methods/context-setter/globals";
import {isSuperAdmin} from "../../common/struct/globalVar";
import {changeStopReminders} from "../../services/CompanyService";
import {globalStoreReducer, UPDATE} from "../../common/methods/context-setter/globalStoreReducer";
import {useNavigate} from "react-router-dom";
import {PRIVATE_URL} from "../../common/struct/urlManager";

export default function OperationMailingSettings(props: {setError: (error: string) => void, setSuccess: (success: string) => void}): JSX.Element {
  const {t} = useTranslation();
  const {setError, setSuccess} = props;
  const STORE = useContext<StoreContext>(AppContext);
  const [store] = STORE;
  const [, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if(!isSuperAdmin()) {
      navigate(PRIVATE_URL.LANDING_PAGE, {replace: true});
    }
  }, []);

  useEffect(() => {
    document.title = t("tab_title.operation.mailingSettings");
  }, []);

  const [localStopReminders, setLocalStopReminders] = useState(
    store.global.company?.stopReminders ?? false
  );

  useEffect(() => {
    setLocalStopReminders(store.global.company?.stopReminders ?? false);
  }, [store.global.company?.stopReminders]);

  const updateStopReminders = async (newValue: boolean): Promise<void> => {
    setLoading(true);
    try {
      const content = await changeStopReminders(store.global.company.id, newValue);
      globalStoreReducer(STORE, {type: UPDATE_COMPANY, method: UPDATE, company: content});
      setSuccess(t('operations.mailing.settings.success_reminders'));
    } catch (e) {
      console.error(e);
      setError(t('operations.mailing.settings.fail_reminders'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card sx={{boxShadow: 1, borderColor: "ornament.dark", mb: 3}}>
        {isSuperAdmin() ? (
          <Box sx={{display: "flex", justifyContent: "start", width: "100%", height: "88px", px: 5, backgroundColor: "ornament.light", alignItems: "center", boxShadow: "inset 0px 1px 0px #CDCEDE"}}>
            <Switch
              checked={localStopReminders}
              onChange={(e, checked) :void => {
                setLocalStopReminders(checked);
                updateStopReminders(checked);
              }}
            />
            <Typography variant="body2" color="text.secondary">
              {t('operations.mailing.settings.stop_reminders',
                {stop_reminders_status: store.global.company?.stopReminders? t('operations.mailing.settings.stop_reminders_on'): t('operations.mailing.settings.stop_reminders_off')})}
            </Typography>
          </Box>
        ) : null}
      </Card>
    </>
  )
}
